import { LAYERS } from 'shared';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import Feature from 'ol/Feature';
import { Stroke, Style } from 'ol/style';
import Point from 'ol/geom/Point';
import Fill from 'ol/style/Fill';
import Circle from 'ol/style/Circle';
import Select from 'ol/interaction/Select';
import { pointerMove } from 'ol/events/condition';
import PopupFeature from 'ol-ext/overlay/PopupFeature';

export default class WoodwiserStemLayer {
    map = null;
    layer = null;

    constructor(map) {
        this.map = map;
        this.init();
    }

    init() {
        this.layer = new VectorLayer({
            title: 'Törzspontok',
            type: LAYERS.TYPES.WOODWISER_STEM,
            visible: false,
            displayInLayerSwitcher: true,
            source: new VectorSource(),
            style: (feature) => {
                const stem = feature.get('stem');
                const treeSpecies = feature.get('treeSpecies');
                const treeSpecie = treeSpecies.find(
                    (treeSpecie) => treeSpecie.treeTextCode === stem.species
                );

                if (!treeSpecie) {
                    console.log('Tree specie not found: ', stem.species);
                }

                return new Style({
                    image: new Circle({
                        radius: 6,
                        fill: new Fill({ color: treeSpecie ? treeSpecie.color : '#ff8310' }),
                        stroke: new Stroke({
                            color: '#ffffff',
                            width: 1,
                        }),
                    }),
                });
            },
        });

        this.initInteractions();
        this.addInteractions();
    }

    initInteractions() {
        this.pointerSelect = new Select({
            condition: pointerMove,
            layers: [this.layer],
        });

        const popup = new PopupFeature({
            select: this.pointerSelect,
            canFix: true,
            template: {
                title: (feature) => {
                    const stem = feature.get('stem');
                    const treeSpecies = feature.get('treeSpecies');
                    const treeSpecie = treeSpecies.find(
                        (treeSpecie) => treeSpecie.treeTextCode === stem.species
                    );

                    return treeSpecie ? treeSpecie.treeHun : 'Ismeretlen fa';
                },
                attributes: {
                    height: {
                        title: 'Famagasság',
                        format: function (value, feature) {
                            const stem = feature.get('stem');
                            return Math.round(stem.height * 100) / 100 + ' m';
                        },
                    },
                    crown: {
                        title: 'Koronaterület',
                        format: function (value, feature) {
                            const stem = feature.get('stem');
                            return Math.round(stem.crownArea * 100) / 100 + ' m2';
                        },
                    },
                    dbh: {
                        title: 'Számított törzsátmérő (DBH)',
                        format: function (value, feature) {
                            const stem = feature.get('stem');
                            return Math.round(stem.dbh * 100) / 100 + ' cm';
                        },
                    },
                    volume: {
                        title: 'Számított fatérfogat',
                        format: function (value, feature) {
                            const stem = feature.get('stem');
                            return Math.round(stem.volume * 100) / 100 + ' m3';
                        },
                    },
                },
            },
        });

        this.map.map.addOverlay(popup);
    }

    addInteractions() {
        this.removeInteractions();
        this.map.map.addInteraction(this.pointerSelect);
    }

    removeInteractions() {
        this.map.map.removeInteraction(this.pointerSelect);
    }

    getLayer() {
        return this.layer;
    }

    update(layer) {
        if (layer.stems !== this.layer.get('stems') && layer.stems) {
            let stemSource = new VectorSource();

            const stems = layer.stems;

            stems.forEach((stem) => {
                if (stem.polygon) {
                    const polygon = JSON.parse(stem.polygon);
                    if (polygon) {
                        const feature = new Feature({
                            geometry: new Point(polygon.coordinates),
                            stem,
                            treeSpecies: layer.treeSpecies,
                        });
                        stemSource.addFeature(feature);
                    }
                }
            });

            this.layer.setSource(stemSource);
            this.layer.set('stems', stems);
        }
    }
}
